"use client";

import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-6"
         style={{ background: "rgb(var(--bg-base))" }}>
      <h1 className="text-[18px] font-semibold" style={{ color: "rgb(var(--foreground))" }}>
        Something went wrong
      </h1>
      <p className="text-[13px]" style={{ color: "rgb(var(--fg-muted))" }}>
        {error.message}
      </p>
      <button
        onClick={reset}
        className="px-4 py-2 rounded-lg text-white text-[13px] font-medium"
        style={{ background: "rgb(var(--accent))" }}
      >
        Try again
      </button>
    </div>
  );
}